module.exports = __webpack_public_path__ + "media/images/workplace/SVG/bulb-6ee8d49f5ea3447dcb51a6095cf1ef7c.svg";